import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useLayoutEffect } from 'react';
import SearchInput from '../search/searchInput';
const Search = _ref => {
  let _ref$indexQuery = _ref.indexQuery,
    indexQuery = _ref$indexQuery === void 0 ? {} : _ref$indexQuery,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'search filter options' : _ref$placeholder,
    serverFilter = _ref.serverFilter;
  const filters = indexQuery.filters;

  // Use refs to store the latest values without causing callback recreation.
  // This ensures handleSearch remains stable across renders while still
  // using the most up-to-date filters and indexQuery when invoked.
  const filtersRef = useRef(filters);
  const indexQueryRef = useRef(indexQuery);
  const serverFilterRef = useRef(serverFilter);

  // Use useLayoutEffect instead of useEffect to ensure refs are updated
  // synchronously after DOM mutations but BEFORE browser paint. This prevents
  // debounced callbacks from calling stale function references during rapid typing.
  useLayoutEffect(() => {
    filtersRef.current = filters;
    indexQueryRef.current = indexQuery;
    serverFilterRef.current = serverFilter;
  }, [filters, indexQuery, serverFilter]);

  // Stable callback that uses refs to access the latest values
  const handleSearch = useCallback(value => {
    serverFilterRef.current(_objectSpread(_objectSpread({}, filtersRef.current), {}, {
      text: value
    }), indexQueryRef.current);
  }, []);
  const clearSearch = useCallback(() => {
    handleSearch('');
  }, [handleSearch]);
  const textProps = {
    size: 'sm',
    className: 't-ls-search',
    text: (filters === null || filters === void 0 ? void 0 : filters.text) || '',
    placeholder,
    loading,
    onChange: handleSearch,
    onClear: clearSearch
  };
  return /*#__PURE__*/React.createElement(SearchInput, textProps);
};
Search.propTypes = {
  serverFilter: PropTypes.func.isRequired,
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      text: PropTypes.string
    })
  }),
  loading: PropTypes.bool,
  placeholder: PropTypes.string
};
export default Search;